import { userProfileDataSelector } from '../../redux/user/selectors';

export default (state) => ({
  userProfile: userProfileDataSelector(state),
});
